import React, { Fragment } from "react";
import { Formik } from "formik";
import Select from "react-select";
import PageTitle from "../../../layouts/PageTitle";
import { create, updateAction } from "../../../../store/actions/CommonActions";
import CustomTextarea from "../../../components/Forms/CustomInputs/CustomTextarea";
import { guestCountValidationSchema } from "../../../../utils/validationSchemas/MasterDataSchema";
import CustomDropdown from "../../../components/Forms/CustomInputs/CustomDropdown";
import { useSelector } from "react-redux";
import CustomImageUpload from "../../../components/Forms/CustomInputs/CustomImageUpload";
import CustomTextbox from "../../../components/Forms/CustomInputs/CustomTextbox";

const ConfigGuestCountUi = ({
  initialValues,
  handleFormSubmit,
}) => {
  return (
    <Fragment>

      <div className="row container-mxw">
        <div className="col-lg-6">
          <div className="card">
            <div className="card-header d-block">
              <h4 className="card-title">
                Guest Management
              </h4>
              <p>Set limits for the maximum number of guests allowed per pass.</p>
            </div>
            <div className="card-body">
              <div className="basic-form">
                <Formik
                  initialValues={initialValues}
                  validationSchema={guestCountValidationSchema}
                  onSubmit={handleFormSubmit}
                >
                  {({
                    values,
                    errors,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <CustomTextbox
                          fieldName="guest_count"
                          value={values.guest_count}
                          error={errors.guest_count}
                          label={"Maxium Guest Per Pass"}
                          classes={"col-md-12"}
                          handleBlur={handleBlur}
                          inputType={"number"}
                          handleChange={handleChange}
                          inputProps={{
                            min: 0,
                            max: 999,
                            onInput: (e) => {
                              if (e.target.value.length > 3) {
                                e.target.value = e.target.value.slice(0, 3); // limit digits
                              }
                              if (+e.target.value > 999) {
                                e.target.value = 999; // cap value
                              }
                              if (+e.target.value < 0) {
                                e.target.value = 0; // avoid negative
                              }
                            }
                          }}
                        />
                      </div>

                      <div className="float-end">
                        <button
                          type="submit"
                          className="btn me-2 btn-primary"
                          disabled={isSubmitting}
                        >
                          Save
                        </button>
                      </div>
                      {/* <button className="btn btn-danger light">Cancel</button> */}
                    </form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default ConfigGuestCountUi;
